@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.bannerCard {
    background: var(--blue-03);
    border-radius: 20px;
    padding: 12px 16px;
    display: flex;
    font-size: 14px;
    color: var(--brand-indigo);
    margin-bottom: 10px;
    font-family: typography.$font-mont;
    align-items: center;
    @include breakpoints.desktop {
        padding: 12px 16px;
        align-items: center;
        background: var(--blue-03);
        border-radius: 20px;
        display: flex;
        font-size: 14px;
        color: var(--brand-indigo);
        margin-bottom: 10px;
    }
}

.bannerLeft {
    font-family: typography.$font-mont;
    text-align: left;
    width: 80%;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--brand-indigo);
}
.bannerRight {
    text-align: right;
    width: 20%;
    white-space: nowrap;

    a {
      color: var(--brand-indigo);
      text-decoration: underline;
      font-weight: 600;
    }
}

.questMark {
    margin-top: 0;
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
}
.bannerMobLeft {
    margin: 0px 8px 0px 0px;
    display: flex;
    align-items: center;
}
